<div *ngIf="isPageReady" id="printable-invoice" class="h-full flex">
  <div
    class="center no-print p-2 border-2 shadow-lg"
    style="max-width: 8.5in; min-width: 8.5in"
  >
    <div
      *ngIf="flatDetails"
      #printableArea
      class="flex grow flex-col screen-p-20"
      style="overflow: auto"
    >
      <div uni-flex-row class="h1 mt-6 mb-6">
        <span style="flex: auto"
          >Unitec Distribution Systems - Work in Process Tracking</span
        >
      </div>
      <div
        uni-flex-row
        style="justify-content: space-between"
        class="h3 mt-6 mb-20"
      >
        <span>Job Order: {{ joHeaderId }}</span>
        <span>Printed: {{ timestamp }}</span>
      </div>

      <table class="grid-print">
        <thead>
          <tr>
            <th>Manufacturer</th>
            <th>Description</th>
            <th>Style</th>
            <th>Size</th>
            <th class="col-right">Inventory Identifier</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let d of flatDetails">
            <tr>
              <td>{{ d.mfr }}</td>
              <td>{{ d.desc }}</td>
              <td>{{ d.style }}</td>
              <td>{{ d.featureChoicesExtract }}</td>
              <td class="col-right">{{ d.id }}</td>
            </tr>
            <tr *ngFor="let m of d.mods">
              <td></td>
              <td class="td-shade">{{ m.description }}</td>
              <td class="td-shade">{{ m.info }}</td>
              <td class="td-shade"></td>
              <td style="font-weight: bold" class="col-right td-shade">
                {{ m.status }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div uni-flex-row class="accent no-print mb-12">
      <div class="left-buttons">
        <button pButton type="button" class="p-button-raised" (click)="print()">
          <span>Print</span>
        </button>
      </div>

      <div>
        <button
          pButton
          type="button"
          class="p-button-raised"
          (click)="goBack()"
        >
          <span>Go Back</span>
        </button>
      </div>
    </div>
  </div>
</div>
